<!-- <app-header></app-header>
<app-breadcrumb></app-breadcrumb> -->
<div class="wrapper">
  <div class="header">
    <div class="col-4 p-0">
      <div class="row">
        <div class="col-8 search-input">
          <div class="search-bar search">
            <button type="submit" class="msicon"><span class="material-symbols-outlined">
                search</span></button>
            <input matinput="" type="search" placeholder="Search Employee by Name or Id..."
              class="form-control search-button" (keyup)="applyFilter($event.target.value)" [(ngModel)]="searchText">
            <button type="submit" class="msicon" (click)="applyFilter('')" *ngIf="searchText"><span
                class="material-symbols-outlined"> close </span></button>
          </div>
        </div>
        <div class="col-4">
          <div class="roles-dropdown">
            <select class="form-control filter-role" #role (change)="filterByRole($event.target.value)">
              <option [value]="''">All Roles</option>
              <option *ngFor="let user_role of userRoles | keyvalue" [value]="user_role.key">{{user_role.value}}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="col-2 toggle">
      <mat-slide-toggle class="slide-toggle" color="primary" [(ngModel)]="isProfileCompleted" (change)="getdata()">
        <label class="fw-500 pt-3">Profile Completed</label>
      </mat-slide-toggle>
    </div>


    <div class="cards alignment col-5">
      <div class="card card-align">
        <span class="fw-500">Total</span>
        <span>{{profileCompletedCounts?.totalEmployees}}</span>
      </div>

      <div class="card card-align">
        <span class="fw-500">Completed</span>
        <div class="row">
          <span class="col-6 items-center">{{profileCompletedCounts?.profileCompletedEmployees}}</span>
          <div class="col-3 download-popup">
            <i class="fas fa-download py-3 px-bottom-icons py-3 cursor-pointer"
              (click)="exportExcel(true,profileCompletedCounts?.profileCompletedEmployees)">
            </i>
          </div>
        </div>
      </div>
      <div class="card card-align">
        <span class="fw-500">Not Started</span>
        <div class="row">
          <span class="col-6 items-center">{{profileCompletedCounts?.profileNotCompletedEmployees}}</span>
          <div class="col-3 download-popup">
            <i class="fas fa-download py-3 px-bottom-icons py-3 cursor-pointer"
              (click)="exportExcel(false,profileCompletedCounts?.profileNotCompletedEmployees)">
            </i>
          </div>
        </div>
      </div>
      <div class="card card-align">
        <span class="fw-500">Roles</span>
        <div class="row">
          <span class="col-6 items-center">{{profileCompletedCounts?.totalEmployees}}</span>
          <div class="col-3 download-popup">
            <i class="fas fa-download py-3 px-bottom-icons py-3 cursor-pointer"
              (click)="exportExcel('',profileCompletedCounts?.totalEmployees)">
            </i>
          </div>
        </div>
      </div>
      <div class="card card-align">
        <span class="fw-500">Certificates</span>
        <div class="row">
          <span class="col-6 items-center">{{this.totalCertificates}}</span>
          <div class="col-3 download-popup">
            <i class="fas fa-download py-3 px-bottom-icons py-3 cursor-pointer" (click)="exportExcelForCertificate()">
            </i>
          </div>
        </div>
      </div>
      <div class="card card-align">
        <span class="fw-500">Stats</span>
        <div class="row">
          <span class="col-6 items-center"></span>
          <div class="col-3 download-popup">
            <i class="fa fa-bar-chart py-3 px-bottom-icons py-3 cursor-pointer stats-icon"
              (click)="openDatesTemplate()">
            </i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="data-grid">

    <mat-table [dataSource]="dataSource" matSort>

      <!-- ID Column -->
      <ng-container matColumnDef="employeeId">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Employee ID </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.employeeId}} </mat-cell>
      </ng-container>

      <!-- Progress Column -->
      <ng-container matColumnDef="firstName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> First Name </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.firstName}}</mat-cell>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="lastName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.lastName}} </mat-cell>
      </ng-container>

      <!-- Color Column -->
      <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Email </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.email}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="competency">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Competency </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.competency}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="subCompetency">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Sub Competency </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.subCompetency}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="resume">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Resume</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.resume ? 'Uploaded' : 'Not Uploaded'}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="role">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Role</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span *ngFor="let role of row.role" [innerHTML]="userRoles[role]">
          </span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="yearsOfExperience">
        <mat-header-cell *matHeaderCellDef > Years of Experience </mat-header-cell>
        <mat-cell *matCellDef="let row">
      <ng-container *ngIf="row.expYears > 0 || row.expMonths > 0">
        <span *ngIf="row.expYears > 0">
        {{row.expYears}}{{row.expYears === 1 ? 'yr' : 'yr(s)'}}
        </span>
        <span *ngIf="row.expMonths > 0">
        {{row.expYears > 0 ? ' ' : ''}}{{row.expMonths}}{{row.expMonths === 1 ? 'mo' : 'mo(s)'}}
        </span>
      </ng-container>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="updatedOn">
      <mat-header-cell *matHeaderCellDef > Updated On </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.updatedOn }} </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" style="z-index: 3;"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;">
      </mat-row>
    </mat-table>

    <mat-paginator [length]="totalRecords" [pageSize]="10" [pageSizeOptions]="[5,10,15,20]" aria-label="Select page"
      (page)="getPaginatorData($event)"></mat-paginator>
  </div>
</div>